import React from 'react';
import { Route } from 'react-router';
import { NewMilkabilityReport, Overview } from '../screens';
import { milkabilityRoutePaths } from './route-paths';

/** Route definitions for the milkability screens. */
export const milkabilityRoutes = [<Route path={milkabilityRoutePaths.overview} element={<Overview />} key="milkability" />, <Route path={milkabilityRoutePaths.newReport} element={<NewMilkabilityReport />} key="milkability-new" />, <Route path={milkabilityRoutePaths.reportDetail} element={<NewMilkabilityReport />} key="milkability-detail" />];